// extracted by mini-css-extract-plugin
export default {"list":"rK8sjF","item":"RDRdYv","menuButton":"xIq6aC","menuIcon":"kLWq8w","link":"rKHfxF","linkThemePurple":"u2OvC7","linkThemePink":"d_MHIo","icon":"xpg_Sk"};